/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseDetailmaskeSetting } from './DatabaseDetailmaskeSetting';
import {
    DatabaseDetailmaskeSettingFromJSON,
    DatabaseDetailmaskeSettingFromJSONTyped,
    DatabaseDetailmaskeSettingToJSON,
} from './DatabaseDetailmaskeSetting';

/**
 * Aufbau der Detailmaske JE GERAET — genau wie `navigation` bei den Uebersichten (Vorgabe des Betreibers 28.08.2026: "alles analog der Uebersichtsanzeige").
 * WARUM JE GERAET: Der Side-by-Side-Aufbau lebt davon, dass links und rechts nebeneinander Platz haben; auf dem Telefon ist er sinnlos. Ein einziger Wert fuer alle Geraete zwaenge den Betreiber zu einem Kompromiss, der auf keinem Geraet gut ist.
 * @export
 * @interface DatabaseDetailmaskeProperties
 */
export interface DatabaseDetailmaskeProperties {
    /**
     * 
     * @type {DatabaseDetailmaskeSetting}
     * @memberof DatabaseDetailmaskeProperties
     */
    desktop?: DatabaseDetailmaskeSetting;
    /**
     * 
     * @type {DatabaseDetailmaskeSetting}
     * @memberof DatabaseDetailmaskeProperties
     */
    tablet?: DatabaseDetailmaskeSetting;
    /**
     * 
     * @type {DatabaseDetailmaskeSetting}
     * @memberof DatabaseDetailmaskeProperties
     */
    mobile?: DatabaseDetailmaskeSetting;
}

/**
 * Check if a given object implements the DatabaseDetailmaskeProperties interface.
 */
export function instanceOfDatabaseDetailmaskeProperties(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseDetailmaskePropertiesFromJSON(json: any): DatabaseDetailmaskeProperties {
    return DatabaseDetailmaskePropertiesFromJSONTyped(json, false);
}

export function DatabaseDetailmaskePropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseDetailmaskeProperties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'desktop': !exists(json, 'desktop') ? undefined : DatabaseDetailmaskeSettingFromJSON(json['desktop']),
        'tablet': !exists(json, 'tablet') ? undefined : DatabaseDetailmaskeSettingFromJSON(json['tablet']),
        'mobile': !exists(json, 'mobile') ? undefined : DatabaseDetailmaskeSettingFromJSON(json['mobile']),
    };
}

export function DatabaseDetailmaskePropertiesToJSON(value?: DatabaseDetailmaskeProperties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'desktop': DatabaseDetailmaskeSettingToJSON(value.desktop),
        'tablet': DatabaseDetailmaskeSettingToJSON(value.tablet),
        'mobile': DatabaseDetailmaskeSettingToJSON(value.mobile),
    };
}

